var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9308 4H10.0737C10.3893 4 10.6451 4.25584 10.6451 4.57143V11.4286C10.6451 11.7442 10.3893 12 10.0737 12H0.930804C0.615215 12 0.359375 11.7442 0.359375 11.4286V4.57143C0.359375 4.25584 0.615215 4 0.930804 4H2.07366V3.42857C2.07366 1.53502 3.60868 0 5.50223 0C7.39577 0 8.9308 1.53502 8.9308 3.42857V4ZM4.9308 8.41851V9.71429H6.07366V8.41851C6.41526 8.22091 6.64509 7.8516 6.64509 7.42857C6.64509 6.79737 6.13343 6.28571 5.50223 6.28571C4.87103 6.28571 4.35937 6.79737 4.35937 7.42857C4.35937 7.8516 4.5892 8.22091 4.9308 8.41851ZM7.78795 4V3.42857C7.78795 2.16621 6.76457 1.14286 5.50223 1.14286C4.23987 1.14286 3.21652 2.16621 3.21652 3.42857V4H7.78795Z",
    fill: "#454A54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockerIcon);
export default __webpack_public_path__ + "static/media/locker-icon.f0e298ad38f53117bf5b688832f7641b.svg";
export { ForwardRef as ReactComponent };